<template>
  <div
    :style="`width: 100%; padding-right: ${
      noPadding ? '0' : '20px'
    } !important;`"
  >
    <div style="position: relative">
      <label v-if="showLabel" class="defaultLabel"> {{ label }}: </label>

      <v-select
        :value="selected"
        :label="text"
        :options="dataList"
        :loading="loading"
        :disabled="isDisabled"
        @input="setSelected"
        @search="onSearchInput"
      >
        <template #no-options>
          <div>Resultado não encontrado!</div>
        </template>

        <template #spinner="{ loading }">
          <div
            v-if="loading"
            style="border-left-color: rgba(88, 151, 251, 0.71)"
            class="vs__spinner"
          ></div>
        </template>
      </v-select>
    </div>
  </div>
</template>

<script>
import { debounce } from "../../../utils/debounce";

export default {
  name: "SimpleStudentSelect",
  props: {
    dataInput: { type: [String, Number], default: "" },
    text: { type: String, default: "name" },
    value: { type: String, default: "id" },
    onSearch: { type: Function, required: true },
    label: { type: String, default: "Alunos" },
    isDisabled: { type: Boolean, default: false },
    showLabel: { type: Boolean, default: true },
    noPadding: { type: Boolean, default: false },
  },
  data() {
    return {
      dataList: [],
      selected: null,
      loading: false,
    };
  },
  created() {
    this.debouncedSearch = debounce((search, loading) => {
      this.fetchData(search).finally(() => {
        if (loading) loading(false);
      });
    }, 350);

    this.fetchData("");
  },
  methods: {
    async fetchData(searchQuery = "") {
      this.loading = true;
      try {
        const result = await this.onSearch(searchQuery);
        this.dataList = Array.isArray(result) ? result : result?.data || [];
        if (this.dataInput && !this.selected) {
          this.selected =
            this.dataList.find(
              (item) => String(item[this.value]) === String(this.dataInput)
            ) || null;
        }
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
        this.dataList = [];
      } finally {
        this.loading = false;
      }
    },

    onSearchInput(search, loading) {
      if (search.length > 0) {
        loading(true);
        this.debouncedSearch(search, loading);
      }
    },

    setSelected(itemSelect) {
      this.selected = itemSelect;

      if (itemSelect) {
        this.$emit("update:dataInput", itemSelect[this.value]);
        this.$emit("selectItem", itemSelect);
      } else {
        this.$emit("update:dataInput", "");
        this.$emit("selectItem", null);
      }
    },
  },
  watch: {
    dataInput(newVal) {
      if (!newVal) {
        this.selected = null;
      } else if (
        !this.selected ||
        String(this.selected[this.value]) !== String(newVal)
      ) {
        this.selected =
          this.dataList.find(
            (item) => String(item[this.value]) === String(newVal)
          ) || null;
      }
    },
  },
};
</script>

<style>
.loader {
  text-align: center;
  color: #bbbbbb;
  height: 30px !important;
  padding-top: 5px;
}

.boxFilter {
  display: flex;
  height: 30px;
  justify-content: space-between;
  background-color: white;
  position: absolute;
  top: 33px;
  right: -40px;
  z-index: 500;
  border-radius: 5px;
  box-shadow: 0 0 3px 0 #0000006b;
}

.boxFilter::before {
  content: "";
  position: absolute;
  top: -8px;
  right: 3px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 10px solid white;
  z-index: -99999;
}

.vs__dropdown-toggle {
  height: 30px;
}

.vs__search {
  font-size: 12px !important;
  color: #495057 !important;
}

.vs__dropdown-option {
  white-space: normal !important;
  font-size: 11px !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.vs__dropdown-menu {
  overflow-y: auto !important;
  overflow-x: hidden !important;
  font-size: 12px;
}

.vs__selected {
  font-size: 12px !important;
}

.vs__dropdown-toggle {
  width: 100%;
  white-space: normal !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  padding: 0 0 4px;
}

.vs1__listbox {
  width: 100%;
  white-space: normal !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.vs__dropdown-option--highlight {
  white-space: normal !important;
  word-break: break-all !important;
}

.vs__dropdown-menu {
  padding: 0 0 5px 0 !important;
  text-overflow: ellipsis !important;
}

.vs__dropdown-menu {
  padding: 0 0 5px 0 !important;
}

.floatLabel {
  position: absolute;
  left: 3px;
  font-size: 8.5px;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  top: -9px;
  left: 7px;
  pointer-events: none;
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
  height: 12px;
  background-color: #ffff;
  padding: 0 0.2em;
  z-index: 999;
}

.defaultLabel {
  position: absolute;
  margin-bottom: 0px;
  font-size: 10px;
  bottom: 21px;
  left: 7px;
  z-index: 2;
  padding: 2px;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: #fafafa;
  font-weight: 600;
  z-index: 100;
}

.iconSelectInfinit {
  position: absolute;
  right: -18px !important;
  top: 0 !important;
  z-index: 10;
  background-color: #7a9c87;
  color: whitesmoke;
  height: 100%;
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 0 0.25rem 0.25rem 0;
}

.iconDisabledInfinit {
  pointer-events: none !important;
}

.iconFilterSelectInfinit {
  position: absolute;
  right: -38px !important;
  top: 0 !important;
  z-index: 10;
  background-color: #7a9c87;
  color: whitesmoke;
  height: 100%;
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 0 0.25rem 0.25rem 0;
  border-left: solid 1px rgba(129, 129, 129, 0.26);
}

.iconFilterSelectInfinit:hover {
  background: #006256;
}

.iconDisabledInfinit {
  pointer-events: none !important;
}

.containerRadio {
  display: flex;
}

.containerRadio label {
  display: flex;
  cursor: pointer;
  font-weight: 500;
  position: relative;
  overflow: hidden;
  margin-bottom: 0;
}

.containerRadio label input {
  position: absolute;
  left: -9999px;
}

.iconSelectInfinit:hover {
  background: #006256;
}

.containerRadio label input:checked + span {
  background-color: #f3f2f2;
  color: rgb(0, 0, 0);
}

.containerRadio label input:checked + span:before {
  box-shadow: inset 0 0 0 0.4375em #006256;
}

.containerRadio label span {
  display: flex;
  align-items: center;
  padding: 0.375em 0.75em 0.375em 0.375em;
  border-radius: 2px;
  transition: 0.25s ease;
  font-size: 11px;
}

.containerRadio label span:hover {
  background-color: #e6e6e6;
}

.containerRadio label span:before {
  display: flex;
  flex-shrink: 0;
  content: "";
  background-color: #fff;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  margin-right: 0.375em;
  transition: 0.25s ease;
  box-shadow: inset 0 0 0 0.1em #006256;
}

@media (max-width: 768px) {
  .floatLabel {
    position: absolute;
    left: 3px;
    font-size: 11px;
    font-family: Poppins-Regular, sans-serif !important;
    font-weight: 600;
    top: -10px;
    left: 7px;
    pointer-events: none;
    white-space: nowrap !important;
    text-overflow: ellipsis;
    color: #666360;
    height: 12px;
    background-color: #ffff;
    padding: 0 0.2em;
    z-index: 999;
  }
}
</style>